import React from 'react';
import { withTheme } from 'styled-components';
import AlmeLiveChatBannerTemplate from '../../AlmeLiveChatBanner/AlmeLiveChatBannerTemplate';
export function isValidLiveChatSessionEndResponse(response) {
    return response.extensionData.MessageOrigin === "Session-End";
}
const AlmeLiveChatEnd = (props) => {
    var _a, _b;
    if (!isValidLiveChatSessionEndResponse(props.response)) {
        return null;
    }
    const responseRevision = (props.responseId || props.response.responseRevision).toString();
    let mainText, subText;
    const sessionEndReason = props.response.extensionData.SessionEndReason, operatorName = props.response.extensionData.operatorName, sessionEndConfig = props.appConfig.liveChatBanner.ended, defaultOperatorName = props.appConfig.liveChatBanner.defaultRepName, isSessionTimeout = props.response.extensionData.isSessionTimeout;
    if (sessionEndReason === "Agent") {
        mainText = sessionEndConfig.agent.main.text;
        subText = React.createElement(React.Fragment, null,
            React.createElement("div", null, (operatorName || defaultOperatorName) + sessionEndConfig.agent.sub.operatorLefttext),
            React.createElement("div", { style: { marginTop: '0.2em' } }, sessionEndConfig.agent.sub.text));
    }
    else if (sessionEndReason === "User") {
        if (isSessionTimeout) {
            mainText = sessionEndConfig.timeout.main.text;
            subText = sessionEndConfig.timeout.sub.text;
        }
        else {
            mainText = sessionEndConfig.user.main.text;
            subText = sessionEndConfig.user.sub.text;
        }
    }
    else if (sessionEndReason === "NotEngaged") {
        mainText = sessionEndConfig.user.main.text;
        subText = sessionEndConfig.user.sub.text;
    }
    else {
        mainText = sessionEndConfig.error.main.text;
        subText = sessionEndConfig.error.sub.text;
    }
    return (React.createElement(AlmeLiveChatBannerTemplate, { icon: ["fal", "user-times"], iconColor: (_a = props.theme) === null || _a === void 0 ? void 0 : _a.danger, mainText: mainText, mainTextColor: (_b = props.theme) === null || _b === void 0 ? void 0 : _b.dangerHeader, subText: subText, responseRevision: responseRevision }));
};
export default withTheme(AlmeLiveChatEnd);
